<ng-container *ngFor="let segment of serviceSegmentItems$ | async; let lastSegment = last; let i = index">
  <fin-inform-block
    *ngIf="i === 0 && safThankYouForJoiningUsNotification$ | async as safThankYouForJoiningUsNotification"
    class="block ms-large-b"
    data-testid="saf-thank-you-for-joining-us"
    [title]="safThankYouForJoiningUsNotification.teaserTitle"
  >
    <cms-unstyled-fragment
      class="block ms-xsmall-y ms-xlarge-l"
      [cmsContent$]="safThankYouForJoiningUsNotification$"
      [showTitle]="false"
    ></cms-unstyled-fragment>
  </fin-inform-block>

  <fin-included-product-heading
    class="block ps-xsmall-y nordic-blue-25-bg rounded-medium ms-medium-b"
    [locationCodes]="[segment.departure.locationCode, segment.arrival.locationCode]"
    [operatedByText]="
      (hasNonAySegments$ | async) ? ('operatedBy' | finLocalization: [segment.operatingAirline.name]) : ''
    "
    [locations]="(cartOrOrder$ | async).locations"
  >
  </fin-included-product-heading>

  <fin-inform-block
    *ngIf="showUpsellPerPax && service.category === Category.LOUNGE && service.upsell?.hasPlusTierBenefit === true"
    class="block ms-medium-b"
    [title]="'MMB.includedProducts.availableForSell.lounge.plusTireBenefit.title' | finLocalization"
  >
    <ul class="list-disc-style">
      <li>{{ 'MMB.includedProducts.availableForSell.lounge.plusTireBenefit.child' | finLocalization }}</li>
      <li>{{ 'MMB.includedProducts.availableForSell.lounge.plusTireBenefit.guest' | finLocalization }}</li>
    </ul>
  </fin-inform-block>

  <fin-inform-block
    *ngIf="segment.complimentaryServices.length > 0"
    class="block ms-medium-b"
    [title]="'MMB.includedProducts.availableForSell.meal.infoTitle' | finLocalization"
  >
    <ul *ngFor="let item of segment.complimentaryServices" class="list-disc-style">
      <li>{{ item.displayName }}</li>
    </ul>
  </fin-inform-block>

  <ng-container
    *ngIf="segment.operatingAirline.code !== 'AY' && showUpsellPerPax && service.category === Category.SEAT"
  >
    <div class="flex alert-50-bg ps-medium ms-medium-t rounded-medium">
      <fcom-icon class="icon-medium ms-small-r" [name]="SvgLibraryIcon.ALERT_TRIANGLE"></fcom-icon>
      <div class="font-body-1">
        {{ 'MMB.includedProducts.availableForSell.seat.notAY' | finLocalization }}
      </div>
    </div>
  </ng-container>

  <ul
    class="no-list-style"
    *ngIf="segment.operatingAirline.code === 'AY' || service.category !== Category.SEAT || showNonAYSeats"
  >
    <ng-container *ngFor="let pax of segment.passengers; let lastPassenger = last">
      <li
        [ngClass]="{
          'pr-xsmall-t': !showUpsellPerPax,
          'pr-xxsmall-t': showUpsellPerPax,
          'border-bottom-dotted':
            (!lastPassenger && !showUpsellPerPax) ||
            (lastPassenger && includeSeatActionButtons && service.category === Category.SEAT),
          'pr-small-b':
            !lastPassenger ||
            !lastSegment ||
            (lastPassenger && includeSeatActionButtons && service.category === Category.SEAT),
        }"
      >
        <div class="ms-small-l relative">
          <div
            data-hj-suppress
            *ngIf="(pax.passengerTypeCode !== FinnairPassengerCode.INF && showUpsellPerPax) || !showUpsellPerPax"
            class="font-body-1 pax-info nordic-blue-300-text bold-type ms-medium-b ms-xlarge-l"
          >
            <ng-container
              *ngTemplateOutlet="paxInfo; context: { pax: pax, isNewUpsell: showUpsellPerPax }"
            ></ng-container>
          </div>

          <fin-grouped-services
            class="block"
            [class.mr-xsmall-l]="!showUpsellPerPax"
            [category]="service.category"
            [groupedServices]="pax.groupedServices"
            [enableUpsellMMB]="showUpsellPerPax"
            [loading]="(service.upsell?.updatingService$ | async) ?? false"
            [isInfant]="pax.passengerTypeCode === FinnairPassengerCode.INF"
            [isCarrierConnect]="isCarrierConnect"
            [isShoppingCart]="isShoppingCart"
            [serviceRemovalInProgress]="(removeProgressInfo$ | async).removeInProgress"
            (selectProduct)="onSelectProduct(service.category, segment.id, pax.id)"
            (continuePurchase)="onContinuePurchase()"
            (removeProduct)="onRemoveProduct($event, pax.id, segment.id)"
          ></fin-grouped-services>
        </div>
      </li>
    </ng-container>
  </ul>

  <div *ngIf="lastSegment && service.category === Category.SAF" class="border-top ms-small-y">
    <cms-unstyled-fragment
      data-testid="saf-each-of-your-contributions"
      class="block ms-small-l ms-small-t"
      [contentUrl$]="'fragments.eachOfYourContributions.url' | finLocalization | finToObservable"
      [showTitle]="false"
    ></cms-unstyled-fragment>

    <fcom-link
      data-testid="saf-impact-contribution"
      class="block bold-type ms-small-l ms-medium-t"
      (afterNavigation)="isModalOpened = true"
    >
      {{ 'ancillaries.saf.impactOfContributionTitle' | finLocalization }}
    </fcom-link>

    <fcom-modal
      *ngIf="safProductInfo$ | async as safProductInfo"
      [(open)]="isModalOpened"
      [title]="safProductInfo.teaserTitle"
    >
      <fcom-image *ngIf="safProductInfo.picture" [imageData]="safProductInfo.picture" [ratio]="'21x9'"></fcom-image>
      <div class="pr-medium">
        <h3 class="font-heading-4 ms-large-b ps-large-b border-bottom" data-testid="impact-saf-thank-you">
          {{ 'ancillaries.saf.contributionThankYouTitle' | finLocalization }}
        </h3>
        <cms-unstyled-fragment [showTitle]="false" [cmsContent$]="safProductInfo$"></cms-unstyled-fragment>
        <fcom-link
          data-testid="read-more-saf-impact"
          class="block external-link bold-type ms-xlarge-t ms-medium-be"
          [href]="'ancillaries.saf.readMore.url' | finLocalization"
          [external]="true"
          [openInNewTab]="true"
          >{{ 'ancillaries.saf.readMore.text' | finLocalization }}</fcom-link
        >
      </div>
    </fcom-modal>
  </div>

  <ng-container
    *ngIf="includeSeatActionButtons && service.category === Category.SEAT && lastSegment"
    [ngTemplateOutlet]="seatButtons"
  ></ng-container>
</ng-container>

<ng-template #paxInfo let-pax="pax" let-isNewUpsell="isNewUpsell">
  <ng-container *ngIf="!pax.associatedInfantName">{{ pax.firstName }} {{ pax.lastName }}</ng-container>

  <ng-container *ngIf="pax.associatedInfantName">
    <ng-container *ngIf="isNewUpsell; else oldWithInfant">
      {{ pax.firstName }} {{ pax.lastName }} ({{
        'passenger.withInfant' | finLocalization: { withInfantFullName: pax.associatedInfantName } | finToLowerCase: ''
      }})
    </ng-container>

    <ng-template #oldWithInfant>
      {{
        'MMB.labels.travellingWithInfant'
          | finLocalization: { firstName: pax.firstName, lastName: pax.lastName, infantName: pax.associatedInfantName }
      }}
    </ng-template>
  </ng-container>
</ng-template>

<ng-template #seatButtons>
  <div class="flex flex--end flex--wrap seat-buttons">
    <fcom-button
      data-testid="seats-clear-button"
      *ngIf="showClearPendingSeatsButton"
      [mode]="ButtonMode.FILL_MOBILE"
      [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
      [text]="'MMB.checkIn.steps.seats.clearSeats' | finLocalization"
      [icon]="{
        name: SvgLibraryIcon.CLOSE_DELETE,
        position: IconPosition.RIGHT,
      }"
      (clickBtn)="clearPendingSeats.emit()"
    >
    </fcom-button>
    <fcom-button
      data-testid="seats-update-button"
      class="mr-xxsmall-b"
      [mode]="ButtonMode.FILL_MOBILE"
      [theme]="ButtonTheme.LIGHT_PRIMARY_NORDIC_BLUE"
      [text]="'MMB.checkIn.steps.seats.viewOrModify' | finLocalization"
      (clickBtn)="viewSeatmap.emit()"
    >
    </fcom-button>
  </div>
</ng-template>
